import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaEmpleados', NominasNominaEmpleados)

function NominasNominaEmpleados($api, $schema) {
  this.get = get
  this.editar = editar

  function get(idEmpresa, idNomina) {
    return $api.get('kendu/nominas/nomina/empleados', {
        idEmpresa: idEmpresa,
        idNomina: idNomina,
      })
      .then(function (data) {
        return data.map(function (item) {
          return format(item)
        })
      })
  }

  function editar(idNomina, idEmpresa, idEmpleado, importe) {
    return $api.update('kendu/nominas/nomina/empleados/suministro/editar', {
      idNomina: idNomina,
      idEmpresa: idEmpresa,
      idEmpleado: idEmpleado,
    }, {
      importe: importe,
    }, {clearCache: 'nominas'})
  }

  function format(data, reverse) {
    return $schema(data, {
      Subtotal: 'number',
      Comision_Porcentaje: 'number',
      Comision_Importe: 'number',
      Total: 'number',
      Saldo: 'number',
      Status: 'boolean',
    }, reverse)
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Empleados.js